"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsStartLabelPlacement = void 0;
var checkIsStartLabelPlacement = function (labelPlacement) { return (labelPlacement === 'start'); };
exports.checkIsStartLabelPlacement = checkIsStartLabelPlacement;
